import * as React from 'react'

function SvgStethoscope(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.233 2.588a1.136 1.136 0 00-1.05-.018l-.453.215a.952.952 0 00-.036.016H3.361c-.424 0-.91.299-.91.857v4.259c0 .709.178 1.379.46 2.004l.006.013.006.013c.318.615.75 1.154 1.291 1.615a6.203 6.203 0 001.863 1.085l.005.001c.438.16.9.266 1.364.33v3.456c0 .709.178 1.379.46 2.004l.007.014.006.012c.318.615.75 1.154 1.29 1.616a6.206 6.206 0 001.864 1.084l.007.002a6.642 6.642 0 002.272.384c.789 0 1.542-.144 2.257-.379l.011-.003.011-.004a6.206 6.206 0 001.863-1.085c.542-.461.974-1 1.291-1.615l.004-.007c.323-.651.47-1.328.47-2.023v-3.517c1.281-.33 2.291-1.333 2.291-2.63 0-1.611-1.49-2.766-3.15-2.766s-3.151 1.155-3.151 2.767c0 1.3.989 2.308 2.214 2.645v3.523c0 1.79-1.754 3.401-4.085 3.401s-4.085-1.61-4.085-3.4V13c.463-.064.926-.17 1.364-.33l.004-.001a6.206 6.206 0 001.863-1.085c.542-.461.974-1 1.291-1.615l.004-.007c.323-.651.47-1.328.47-2.023v-4.28c0-.559-.487-.858-.911-.858h-1.334l-.476-.225a1.14 1.14 0 00-1.032-.005l-.015.008-.016.009c-.269.153-.535.441-.535.873V3.9c0 .395.25.711.535.873.173.098.372.138.53.138.188 0 .353-.042.508-.126l.44-.209.036-.016h.474v3.4c0 1.791-1.754 3.402-4.085 3.402s-4.085-1.61-4.085-3.401V4.56h.397l.477.225c.167.09.356.126.507.126.197 0 .368-.046.53-.138.269-.153.535-.442.535-.873v-.44c0-.394-.251-.71-.536-.872zm10.862 7.7c0-.495.492-1.03 1.304-1.03s1.304.535 1.304 1.03-.492 1.03-1.304 1.03-1.304-.535-1.304-1.03z"
        fill={props.color || 'currentColor'}
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgStethoscope)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
